// Häufige Fragen der Startseite — sichtbarer Inhalt (HomeFAQ) und
// FAQPage-Schema (routes/index.tsx) speisen sich aus derselben Quelle.
export const homeFaqItems = [
  {
    question: "Was macht Enno & Jens genau?",
    answer:
      "Enno & Jens ist eine Agentur aus Wernigerode im Harz. Wir entwickeln Webseiten, betreuen SEO und GEO, integrieren Buchungs- und Fachsoftware und beraten kleine und mittlere Unternehmen zu Digitalisierung und KI – von Claude, Gemini und Microsoft Copilot bis zu lokalen Open-Source-Modellen wie Ollama, Llama und Mistral.",
  },
  {
    question: "Für welche Regionen und Branchen arbeitet die Agentur?",
    answer:
      "Wir arbeiten hauptsächlich für Unternehmen in Wernigerode, Halberstadt, Quedlinburg und dem gesamten Harz, aber auch überregional in Sachsen-Anhalt und Deutschland. Branchenschwerpunkte: Ärzte & Praxen, Hotels & Ferienwohnungen, Steuerberater, Industrie, Immobilien, E-Commerce und Vereine.",
  },
  {
    question: "Was kostet eine professionelle Webseite bei Enno & Jens?",
    answer:
      "Der Preis hängt von Umfang, Funktionen und Integrationen ab (z. B. Buchungssystem, Mehrsprachigkeit, Shop). Wir starten mit einem kostenlosen Erstgespräch und einem transparenten Festpreis-Angebot. Für kleinere Auftritte beginnen Projekte typisch im niedrigen vierstelligen Bereich.",
  },
  {
    question: "Ist ein Erstgespräch kostenlos?",
    answer:
      "Ja. Erstgespräch und Beratung zur Machbarkeit Ihres Projekts sind kostenlos und unverbindlich. Zusätzlich bieten wir einen kostenlosen Webseitencheck an – mit Analyse zu Performance, Mobile-Darstellung und SEO inklusive persönlicher Besprechung.",
  },
  {
    question: "Was ist GEO – und braucht mein Unternehmen das?",
    answer:
      "GEO (Generative Engine Optimization) bedeutet, Inhalte so aufzubereiten, dass KI-Systeme wie ChatGPT, Gemini oder Perplexity Ihr Unternehmen bei Nutzerfragen tatsächlich zitieren. Wenn Ihre Kundinnen und Kunden zunehmend KI statt Google fragen, ist GEO die logische Ergänzung zu klassischem SEO.",
  },
  {
    question: "Sind eure Lösungen DSGVO-konform?",
    answer:
      "Ja. Wir setzen konsequent DSGVO-konforme Standards um: sichere Formulare, saubere Cookie-Verwaltung, eRecht24-basierte Datenschutzerklärungen und – wo sensibel – lokale bzw. europäische Hosting- und KI-Lösungen (Ollama, Llama, Mistral) statt US-Cloud-Diensten.",
  },
];
